import { z } from 'zod';
import { TIMEFRAMES, timeframeSchema } from './timeframe.js';
export const RSI_DEFAULT_PERIOD = 14;
export const RSI_OVERBOUGHT = 70;
export const RSI_OVERSOLD = 30;
/**
 * Timeframes RSI is read on: all of them except the offset H4 variants.
 *
 * H4_1..H4_3 are the same four hours cut at shifted boundaries. That matters
 * for where a candle's body sits, but RSI over 14 bars barely moves between
 * the cuts, so they only repeated the H4 reading three more times.
 */
export const RSI_TIMEFRAMES = TIMEFRAMES.filter((tf) => tf !== 'H4_1' && tf !== 'H4_2' && tf !== 'H4_3');
export const divergenceSchema = z.object({
    id: z.string(),
    kind: z.enum(['regular', 'hidden']),
    bias: z.enum(['bullish', 'bearish']),
    fromTime: z.number().int(),
    fromPrice: z.number(),
    fromRsi: z.number(),
    toTime: z.number().int(),
    toPrice: z.number(),
    toRsi: z.number(),
    barsApart: z.number().int(),
    rsiDelta: z.number(),
});
export const rsiAnalysisSchema = z.object({
    timeframe: z.string(),
    value: z.number().nullable(),
    zone: z.enum(['overbought', 'oversold', 'neutral']),
    slope: z.number(),
    aboveMidline: z.boolean(),
    divergences: z.array(divergenceSchema),
    bias: z.enum(['bullish', 'bearish', 'neutral']),
    strong: z.boolean(),
    score: z.number(),
    reasons: z.array(z.string()),
    bars: z.number().int(),
});
export const rsiResponseSchema = z.object({
    symbol: z.string(),
    timeframe: timeframeSchema,
    period: z.number().int(),
    digits: z.number().int(),
    storedGmtOffsetSec: z.number().int(),
    points: z.array(z.object({ time: z.number().int(), value: z.number() })),
    analysis: rsiAnalysisSchema,
});
export const rsiSummaryResponseSchema = z.object({
    symbol: z.string(),
    period: z.number().int(),
    timeframes: z.array(rsiAnalysisSchema),
});
/**
 * How many bars each timeframe is analysed over.
 *
 * Shared by the chart page and the summary endpoint so the sidebar can never
 * report a different verdict from the chart beside it — the same mistake the gap
 * module made before its windows were centralised.
 */
export const RSI_SCAN_BARS = {
    M1: 1500,
    M5: 1500,
    M15: 1200,
    M30: 1200,
    H1: 1200,
    H4: 1000,
    H4_1: 1000,
    H4_2: 1000,
    H4_3: 1000,
    D1: 800,
    W1: 400,
};
export function rsiZone(value) {
    if (value >= RSI_OVERBOUGHT)
        return 'overbought';
    if (value <= RSI_OVERSOLD)
        return 'oversold';
    return 'neutral';
}
//# sourceMappingURL=rsi.js.map